import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadScript, removeScripts, scripts } from "../helpers/utils";

const ScriptManager = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (location?.pathname !== "/") {
      const loadAllScripts = async () => {
        try {
          for (const src of scripts) {
            await loadScript(src);
          }
          console.log("All scripts loaded successfully");
        } catch (error) {
          console.error("Script loading failed:", error);
        }
      };

      loadAllScripts();
      return () => {
        removeScripts();
      };
    }
  }, [location.pathname]);

  return <>{children}</>;
};

export default ScriptManager;
